







import { Provide, Prop, Component, Vue } from 'vue-property-decorator'
import DetailWithPipelines from '@/views/Tasks/Detail/DetailWithPipelines.vue'
import DetailVanilla from '@/views/Tasks/Detail/DetailVanilla.vue'

@Component({
    components: {
        DetailWithPipelines,
        DetailVanilla,
    },
})
export default class TasksDetail extends Vue {
    @Prop({ required: true }) readonly referralId!: string

    get pipelinesEnabled(): boolean {
        return this.$currentCompany.pipelinesEnabled
    }
}
